import { render } from "./NavFooter.vue?vue&type=template&id=73bd8215&scoped=true"
import script from "./NavFooter.vue?vue&type=script&lang=js"
export * from "./NavFooter.vue?vue&type=script&lang=js"

import "./NavFooter.vue?vue&type=style&index=0&id=73bd8215&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bd8215"]])

export default __exports__